<div class="sidebar-inner text-white">
  <!-- Logo -->
  <div class="logo-container text-center">
    <img src="assets/images/logo_images/CIXOR LOGO NEW.png" alt="CIXOR Logo" class="img-fluid logo-img" />
  </div>

  <!-- Navigation -->
  <ul class="nav nav-pills flex-column">
    <li *ngFor="let item of menuItems" class="nav-item mb-1">
      <ng-container *ngIf="item.children; else singleItem">
        <a class="nav-link d-flex align-items-center justify-content-between"
          [class.active]="isGroupActive(item.groupKey!)" (click)="toggleSubMenu(item.groupKey!)" role="button"
          [attr.aria-expanded]="isSubMenuOpen(item.groupKey!)">
          <span class="d-flex align-items-center">
            <i class="bi" [ngClass]="item.icon + ' me-2'"></i>
            <span class="label">{{ item.label }}</span>
          </span>

          <!-- chevron only when NOT collapsed -->
          <i class="bi chevron" *ngIf="!collapsed" [ngClass]="{
              'bi-chevron-down': !isSubMenuOpen(item.groupKey!),
              'bi-chevron-up': isSubMenuOpen(item.groupKey!)
            }"></i>
        </a>

        <!-- inline submenu (expanded mode) -->
        <ul class="nav flex-column ms-4" *ngIf="!collapsed && isSubMenuOpen(item.groupKey!)">
          <li class="nav-item" *ngFor="let subItem of item.children">
            <a [routerLink]="subItem.route" routerLinkActive="active" class="nav-link sub-nav-item">
              <span class="label">{{ subItem.label }}</span>
            </a>
          </li>
        </ul>
      </ng-container>

      <!-- direct link -->
      <ng-template #singleItem>
        <a [routerLink]="item.route" routerLinkActive="active" class="nav-link">
          <i class="bi" [ngClass]="item.icon + ' me-2'"></i>
          <span class="label direct-link-label">{{ item.label }}</span>
        </a>
      </ng-template>
    </li>
  </ul>

  <!-- Version Number -->
  <div class="version-section text-center mt-auto pt-3 pb-2">
    <small class="version-text">V {{ appVersion }}</small>
  </div>

  <!-- Logout -->
  <div class="logout-section mt-auto">
    <a class="nav-link logout-link" (click)="logout()">
      <i class="bi bi-box-arrow-left me-2"></i>
      <span class="label">Log out</span>
    </a>
  </div>
</div>
